import {
  ComparePaymentPlanTypes,
  PaymentPlans,
  PharmacyBillingPageStatuses,
} from '@pharmaplan/common';

import { resetDialog } from '../../reducers/dialogReducer';
import { useAppDispatch } from '../useAppDispatch';
import strings from '../../localization';
import SubscriptionDialogs from '../../components/Profile/PharmacyFlow/PharmacyBilling/ExistingPaymentPlan/SubscriptionDialogs/SubscriptionDialogs';

const { compare, upgrade, view } = ComparePaymentPlanTypes;
const { basic, unlimited } = PaymentPlans;

const useComparePaymentPlan = (
  setPaymentPlan?: React.Dispatch<React.SetStateAction<PaymentPlans>>,
  setPageStatus?: React.Dispatch<
    React.SetStateAction<PharmacyBillingPageStatuses>
  >,
) => {
  const dispatch = useAppDispatch();

  const { cancelFromCompare } = SubscriptionDialogs({ setPageStatus });

  const continuePlan = () => {
    setPageStatus?.(PharmacyBillingPageStatuses.existingPaymentPlan);
  };

  const handleGetStarted = (paymentPlan: PaymentPlans) =>
    () => {
      setPaymentPlan?.(paymentPlan);
      dispatch(resetDialog());
    };

  const config: Record<
    string,
    {
      title: string;
      firstButtonLabel?: string;
      secondButtonLabel?: string;
      firstButtonAction?: () => void;
      secondButtonAction?: () => void;
    }
  > = {
    [compare]: {
      title: strings.comparePlan,
      firstButtonLabel: strings.getStarted,
      secondButtonLabel: strings.getStarted,
      firstButtonAction: handleGetStarted(basic),
      secondButtonAction: handleGetStarted(unlimited),
    },
    [upgrade]: {
      title: strings.planDetails,
      firstButtonLabel: strings.selectPlan,
      secondButtonLabel: strings.continue,
      firstButtonAction: cancelFromCompare,
      secondButtonAction: continuePlan,
    },
    [view]: {
      title: strings.comparePlan,
    },
  };

  return { config };
};

export default useComparePaymentPlan;
